var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"my-5 py-10 px-5"},[_c('div',{staticClass:"text-h3 mb-10 text-center"},[_c('span',{staticClass:"mouse-memoirs"},[_vm._v("Listen To What Parents Said")])])])}
var staticRenderFns = []

export { render, staticRenderFns }